import { createApp } from 'vue';
import App from '@login/App.vue';
import { createRouter } from '@login/router/index';
import '@spectee/assets/css/reset.css';
import '@spectee/assets/css/global.css';
import { createAuth0, Auth0VueClientOptions } from '@auth0/auth0-vue';
import ElementPlus from 'element-plus';
import ja from 'element-plus/es/locale/lang/ja';

const auth0ClientOptions: Auth0VueClientOptions = {
  domain: import.meta.env.VITE_APP_DOMAIN ?? '',
  clientId: import.meta.env.VITE_APP_CLIENT_ID ?? '',
  authorizationParams: {
    redirect_uri: `${window.location.origin}/`,
  },
  cookieDomain: '.spectee.com',
  useRefreshTokens: true,
};

const app = createApp(App)
  .use(createRouter())
  .use(createAuth0(auth0ClientOptions))
  .use(ElementPlus, { locale: ja })
  .mount('#app');
export { app };
